import React from 'react';

import PageWrapper from '../components/PageWrapper';
import Hero from '../sections/home6/Hero';
import Features from '../sections/home6/Features';
import Content1 from '../sections/home6/Content1';

const Home6 = () => {
  return (
    <>
      <PageWrapper
        themeConfig={{
          headerClassName: 'site-header--menu-right',
          footerStyle: 'style4',
        }}
      >
        <Hero className="position-relative pt-25 pt-md-31 pt-lg-35 pb-14 pb-md-19 pb-lg-33 position-relative overflow-hidden" />
        <Features className=" bg-default-6" />
        <Content1 className="pt-23 pt-md-25 pt-lg-35 pb-9 pb-md-14 pb-lg-33 overflow-hidden position-relative" />
      </PageWrapper>
    </>
  );
};
export default Home6;
